module.exports = __webpack_public_path__ + "static/6-1a86f022b121a80ba4f5ad200e122434.png";